import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'

export const useReviewModel = defineStore('review', () => {
  const reviewIsShow = ref<boolean>(false)
  return {
    reviewIsShow
  }
})
